<!-- Administración — landing (ui-redesign). Cabecera tipo listado + opciones de gobernanza. -->
<div class="ds opx">
	<div class="wrap">
		<section class="sheet has-art" style="margin-top: 6px; padding: 22px 26px 26px">
			<div class="list-art" style="background-image: url('/assets/fondos/hero_administration_bg.webp')"></div>

			<div class="opx-head">
				<span class="opx-ic"><lord-icon trigger="hover" src="/assets/icons/sections/administration.json"></lord-icon></span>
				<div class="opx-head-tx">
					<p class="eyebrow">{{ "admin.home.eyebrow" | translate }}</p>
					<h1 class="opx-title">{{ "header.menu.admin" | translate }}</h1>
					<p class="opx-sub">{{ "admin.home.subtitle" | translate }}</p>
				</div>
			</div>

			<div class="adm-grid">
				<button type="button" class="adm-card" *ngFor="let o of options" (click)="go(o.route)">
					<span class="adm-ic"><mat-icon>{{ o.icon }}</mat-icon></span>
					<span class="adm-tx">
						<span class="adm-title">{{ o.titleKey | translate }}</span>
						<span class="adm-desc">{{ o.descKey | translate }}</span>
					</span>
					<span class="adm-go"><mat-icon>chevron_right</mat-icon></span>
				</button>
			</div>
		</section>
	</div>
</div>
